import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

export default class ShipInputSelectField extends PureComponent {
  static propTypes = {
    category: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    required: PropTypes.bool,
    onFormInputSelectShipChange: PropTypes.func.isRequired,
    options: PropTypes.array.isRequired,
    error: PropTypes.string,
    readOnly: PropTypes.bool
  }

  render() {
    return (
      <div className="ship-detail-group">
        <label className={`ship-detail category ${this.props.error ? 'error' : ''}`} htmlFor={this.props.name}>
          {this.props.category}
          {this.props.required ? ' *' : null}
        </label>

        <select
          className={`input-field select-field ${this.props.error ? 'error' : ''}`}
          value={this.props.value}
          onChange={event => {
            this.props.onFormInputSelectShipChange(event.target.value, this.props.name)
          }}
          disabled={this.props.readOnly}
        >
          {this.props.options.map(option => {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            )
          })}
        </select>
        {this.props.error && <div className="input-error-message">{this.props.error}</div>}
      </div>
    )
  }
}
